import { render, staticRenderFns } from "./blockChainView.vue?vue&type=template&id=2eaaa51a&"
import script from "./blockChainView.vue?vue&type=script&lang=js&"
export * from "./blockChainView.vue?vue&type=script&lang=js&"
import style0 from "./blockChainView.vue?vue&type=style&index=0&id=2eaaa51a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports